import { render } from "./BannerItem.vue?vue&type=template&id=d39f1d98&scoped=true"
import script from "./BannerItem.vue?vue&type=script&lang=js"
export * from "./BannerItem.vue?vue&type=script&lang=js"

import "./BannerItem.vue?vue&type=style&index=0&id=d39f1d98&scoped=true&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d39f1d98"]])

export default __exports__